import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NotificationsPage } from './notifications';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    NotificationsPage,
  ],
  imports: [
    IonicPageModule.forChild(NotificationsPage),
    ComponentsModule,
    PipesModule
  ],
})
export class NotificationsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.module.ts